import PropTypes from "prop-types";
import React from "react";
import SVG from "theme/components/icons/base/SVG";
import styled from "theme/libs/styled";

const StyledSVG = styled(SVG)`
    transition: transform ${({ theme }) => theme.transitions.primary};

    &[data-is-active="true"] {
        transform: rotate(45deg);
    }
`;

const PlusIcon = ({ color, isActive, ...props }) => (
    <StyledSVG data-is-active={isActive} fill="none" {...props}>
        <path d="M6 0v12" stroke={color} />
        <path d="M12 6H0" stroke={color} />
    </StyledSVG>
);

PlusIcon.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    isActive: PropTypes.bool,
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

PlusIcon.defaultProps = {
    color: "currentColor",
    height: "20px",
    isActive: false,
    viewBox: "0 0 12 12",
    width: "20px",
};

export default PlusIcon;
